module.exports = __webpack_public_path__ + "static/media/footer-facebook.0ba7d02e.svg";